import { memo } from 'react';
import { useTheme } from '@mui/material/styles';

import { convertPxToNumber } from '../../../../../../constants/helpers/utils';

interface Props {
  cx: number;
  cy: number;
  name: string;
}

const ChartLabelInfo = ({ cx, cy, name }: Props) => {
  const theme = useTheme();

  return (
    <text
      fill={theme.typography.h4.color}
      fontSize={theme.typography.h4.fontSize}
      fontWeight={theme.typography.h4.fontWeight}
      x={cx}
      y={cy + 15}
      dy={convertPxToNumber(theme.typography.h4.fontSize) / 2}
      textAnchor="middle"
    >
      {name}
    </text>
  );
};

export default memo(ChartLabelInfo);
